import { render } from "./TinyPumperIncidentTotals.vue?vue&type=template&id=2b344176"
import script from "./TinyPumperIncidentTotals.vue?vue&type=script&lang=js"
export * from "./TinyPumperIncidentTotals.vue?vue&type=script&lang=js"

import "./TinyPumperIncidentTotals.vue?vue&type=style&index=0&id=2b344176&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__